import { formatInTimeZone } from 'date-fns-tz';
import { HotelIcon } from '@icons';
import { AccommodationLeg } from '@/api/apis/route';

type AccommodationsListProps = {
  legs: AccommodationLeg[];
};

export const AccommodationsList = ({ legs }: AccommodationsListProps) => {
  if (!legs.length) return null;

  return (
    <div className="flex flex-col gap-3">
      {legs.map((leg) => (
        <div key={leg.id} className="flex justify-between items-center">
          <div className="flex gap-1 items-center">
            <div className="text-base-10">
              <HotelIcon />
            </div>
            <span className="text-s-sb text-base-10">Accommodation</span>
          </div>
          <div className="flex flex-col items-end gap-1">
            <span className="text-s-sb text-base-10">{formatInTimeZone(leg.checkInAt, 'UTC', 'MM/dd/yyyy')} -</span>
            <span className="text-s-sb text-base-10">{formatInTimeZone(leg.checkOutAt, 'UTC', 'MM/dd/yyyy')} -</span>
          </div>
        </div>
      ))}
    </div>
  );
};
